import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import SeriesPage from "@/pages/SeriesPage";
import ExpansionDetail from "@/pages/ExpansionDetail";
import EraDetail from "@/pages/EraDetail";
import CatalogPage from "@/pages/CatalogPage";
import ProductDetail from "@/pages/ProductDetail";
import IndividualCards from "@/pages/IndividualCards";
import CardDetail from "@/pages/CardDetail";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Contact from "@/pages/Contact";
import ShippingPayment from "@/pages/legal/ShippingPayment";
import Returns from "@/pages/legal/Returns";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
        <CartProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/serie" element={<SeriesPage />} />
              <Route path="/serie/:slug" element={<ExpansionDetail />} />
              <Route path="/era/:slug" element={<EraDetail />} />
              <Route path="/etb-boxy" element={<CatalogPage mode="etb" />} />
              <Route path="/boostre" element={<CatalogPage mode="boosters" />} />
              <Route path="/novinky" element={<CatalogPage mode="news" />} />
              <Route path="/katalog" element={<CatalogPage mode="search" />} />
              <Route path="/karty" element={<IndividualCards />} />
              <Route path="/karta/:slug" element={<CardDetail />} />
              <Route path="/produkt/:slug" element={<ProductDetail />} />
              <Route path="/pokladna" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/doprava-a-platba" element={<ShippingPayment />} />
              <Route path="/vratenie-tovaru" element={<Returns />} />
              <Route path="/obchodne-podmienky" element={<Terms />} />
              <Route path="/ochrana-osobnych-udajov" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </CartProvider>
        </SettingsProvider>
        <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#111625", border: "1px solid rgba(139,92,246,0.3)", color: "#F8FAFC" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
